import { render, staticRenderFns } from "./Annotate.vue?vue&type=template&id=ededc908"
import script from "./Annotate.vue?vue&type=script&lang=js"
export * from "./Annotate.vue?vue&type=script&lang=js"
import style0 from "./Annotate.vue?vue&type=style&index=0&id=ededc908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports